<script setup> 
    import PremiumPageHeader from '@/Components/PremiumPageHeader.vue';
    import { onMounted, ref, reactive } from 'vue';
    import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
    import { Head, Link } from '@inertiajs/inertia-vue3';
    import BaseIcon from "@/Components/BaseIcon.vue";
    import CardBoxModal from "@/Components/CardBoxModal.vue";
    import {
        mdiArrowRightBoldCircle, mdiTrashCan, mdiCog, mdiArrowUpCircle, mdiArrowDownCircle, mdiArrowDownBold, mdiClipboardEdit, mdiCashPlus, mdiPlusCircle, mdiInformationOutline
        ,mdiCloseThick
    } from "@mdi/js";
    import VueCal from "vue-cal";
    import 'vue-cal/dist/vuecal.css'
    import CardBox from "@/Components/CardBox.vue";
    import TableAdvanced from "@/Components/TableAdvanced.vue";
    import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';
    import CardBoxComponentLoad from '@/Components/CardBoxComponentLoad.vue';
    import BaseButtons from "@/Components/BaseButtons.vue";
    import BaseButton from "@/Components/BaseButton.vue";
    import CardBoxWidget from "@/Components/CardBoxWidget.vue";
    import SectionTitleLineWithButton from "@/Components/SectionTitleLineWithButton.vue";
    //import SectionTitleLineWithButtonUnens from "@/Components/SectionTitleLineWithButtonUnens.vue";// <-- Cambios para agregar más contenido
    import LineChart from "@/Components/Charts/LineChart.vue";
    import BarChart from "@/Components/Charts/BarChart.vue";
    import NotificationAlert from "@/Components/NotificationAlert.vue";
    import BreezeDropdown from '@/Components/Dropdown.vue';
    import BreezeDropdownLink from '@/Components/DropdownLink.vue';
    //import RadarChart from "@/Components/Charts/RadarChart.vue";// Example <-- cambiar a sólo RadarChart y no Example
    // Pruebas
    //import * as chartConfig from "@/Components/Charts/chart.config.js";

    /**
     * 
     * Revisar si este archivo es deprecated
     */

    // Formulario
    import BreezeLabel from '@/Components/Label.vue';
    import BreezeInput from '@/Components/Input.vue';

    // Section Configuration
    import FormField from "@/Components/FormField.vue";
    import FormControl from "@/Components/FormControl.vue";
    import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
    import { Inertia } from '@inertiajs/inertia';


    const props = defineProps({
        titleup: String,
        collaborators: Object,
        //registrosdp: Object,
        message: String,
        relojes: Array,
        entidades: Object,
        cronjob: Object
    });

    //console.log(props.entidades)
    const title = ref(props.titleup)
    //const collaborators = ref((props.entidades.length > 1 ? [] : props.collaboratorActives));
    const registrosSistema = ref([]);
    const setReloj = ref(-1)
    const infoReloj = ref('')
    const entidad = ref(-1)
    const startDate = ref('')
    const endDate = ref('')

    const listarRegistrosSistema = async () => {
        let url = '/relojasistencia/getregistros?entity='+entidad.value+'&start_date='+startDate.value+'&end_date='+endDate.value;
        loading.value = true;
        await axios.get(url).then((response) => {
            let respuesta = response.data
            registrosSistema.value = respuesta.datalist
            console.log(registrosSistema.value)
            
            if(!respuesta.success) {
                showAlert(respuesta.message, 'warning', 30)
                loading.value = false
            } 
            console.log(respuesta.message);
        }).catch((error) => {

            //console.log(error);
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
                showAlert(error.response.data.message, 'danger', 60)
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser 
                // and an instance of http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
                showAlert(error.message, 'danger', 60)
            }
        });
        loading.value = false
    }

    const registrosdp = ref([]);
    const listarRegistrosReloj = async () => {
        //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
        // let url = '/diarion/fromaulas'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+ref_ciclo;
        let url = '/report/relojasistencia/registrosreloj?id='+setReloj.value+'&start_date='+startDate.value+'&end_date='+endDate.value;
        loading.value = true;
        await axios.get(url).then((response) => {
            let respuesta = response.data;
            registrosdp.value = respuesta.datalist;
            console.log(registrosdp.value);
            
            if(!respuesta.success) {
                showAlert(respuesta.message, 'warning', 30)
                loading.value = false
            } 
            console.log(respuesta.message);
        }).catch((error) => {

            //console.log(error);
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
                showAlert(error.response.data.message, 'danger', 60)
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser 
                // and an instance of http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
                showAlert(error.message, 'danger', 60)
            }
        });
        loading.value = false
    }

    // cargar archivo
    const fileSubida = ref('')
    const eventSubirArchivo = (rutaController) => {
        let formData = new FormData();
        //console.log(fileSubida.value);
        formData.append('file', fileSubida.value);
        formData.append('start_date', startDate.value);
        formData.append('end_date', endDate.value);
        axios.post(rutaController,
            formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        ).then(function (response) {
            //alertaSubida.value = 1;
            let respuesta = response.data;
            //let data = respuesta.data.data;
            if (respuesta.success) {
                //alertaSubida.value = 1;
                //mensajes.value = 'Total registros : '+(data.total-1)+'\nRegistrados : '+data.registered+'\nActualizados : '+data.updated;
                //limpiarVal(5000);
                showAlert(respuesta.message, 'success', 8)
                //if (!respuesta.consistencia) messageError.value = respuesta.infoObservados
                //if (respuesta.consistencia) messageError.value = null
                //this.$refs.fileOrder.value = null;// <-- Limpiar input file
                //fileOrder.value = null
                console.log(respuesta.debug)

                // guardar datos temporal para listar
                registrosdp.value = respuesta.datalist;
                console.log(registrosdp.value);

            } else {
                showAlert(respuesta.message, 'danger', 16)
                //alertaSubida.value = 2;
                //mensajes.value = respuesta.data.message;
                //limpiarVal(3000);
            }
        }).catch(function () {
            //alertaSubida.value = 2;
            //limpiarVal(3000);
            showAlert('Registro actualizado', 'danger', 8)
        });
    }

    const handleFileUploadArchivo = (event) => {
        //fileSubida.value = this.$refs.fileSubida.files[0];
        fileSubida.value = event.target.files[0];
        //console.log(event.target.files[0]);
    }

    // Set Reloj

    const claveRelojUser = ref('');
    const rolRelojUser = ref(0)
    const storeRegistros = async () => {

        let url = '/relojasistencia/storeregistros';
        loading.value = true;
        await axios.post(url, {
            'arrayData' : registrosdp.value
        }).then((response) => {
            let respuesta = response.data;
            //console.log(registrosdp.value);
            if(!respuesta.success) {
                showAlert(respuesta.message, 'warning', 30)
            } else {
                showAlert(respuesta.message, 'success') 
                listarRegistrosSistema()
            }
            console.log(respuesta.message);
        }).catch((error) => {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                //console.log(error.response.data);
                //console.log(error.response.status);
                //console.log(error.response.headers);
                showAlert(error.response.data.message, 'danger', 60)
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser 
                // and an instance of http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
                showAlert(error.message, 'danger', 60)
            }
            console.log(error);
        });
        loading.value = false

    }

    const storeRegistro = async () => {

        let url = '/relojasistencia/store';
        if (form.value.id_user && form.value.fecha_hora) {

            loading.value = true;
            await axios.post(url, {
                'id_collaborator' : form.value.id_user,
                'fecha_hora' : form.value.fecha_hora
            }).then((response) => {
                let respuesta = response.data;
                //console.log(registrosdp.value);
                if(!respuesta.success) {
                    showAlert(respuesta.message, 'warning', 30)
                } else {
                    showAlert(respuesta.message, 'success') 
                    listarRegistrosSistema()
                    showModalForm()
                    cleanForm()
                }
                console.log(respuesta.message);
            }).catch((error) => {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    //console.log(error.response.data);
                    //console.log(error.response.status);
                    //console.log(error.response.headers);
                    showAlert(error.response.data.message, 'danger', 60)
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser 
                    // and an instance of http.ClientRequest in node.js
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                    showAlert(error.message, 'danger', 60)
                }
                console.log(error);
            });
            loading.value = false
        } else {
            alert('colaborador y fecha son obligatorios')
        }
    }

    const deleteRegistroSistema = async (id=0, nombre='') => {
    
        let valid = false;
        valid = confirm("Seguro de eliminar el registro "+id+" de "+nombre+" del sistema?")
        if (valid) {

            let url = '/relojasistencia/deleteregistrosistema';
            loading.value = true;
            await axios.put(url, {
                'id' : id,

            }).then((response) => {
                let respuesta = response.data;
                //console.log(registrosdp.value);
                if(!respuesta.success) {
                    showAlert(respuesta.message, 'warning', 30)
                } else {
                    showAlert('Registro eliminado', 'success') 
                    listarRegistrosSistema()
                }
                console.log(respuesta.message);
            }).catch((error) => {
                showAlert(error.message, 'danger', 60)
                console.log(error);
            });
            loading.value = false
        }

    }

    // Por ahora no es posible eliminar
    const deleteRegistroReloj = async (id_user = 0, nombre='') => {
    
        let valid = false;
        valid = confirm("Seguro de eliminar "+nombre+" en el dispositivo")
        if (valid) {

            let url = '/relojasistencia/deleteregistroreloj';
            loading.value = true;
            await axios.put(url, {
                'id' : setReloj.value,
                'id_user' : id_user,

            }).then((response) => {
                let respuesta = response.data;
                //console.log(registrosdp.value);
                if(!respuesta.success) {
                    showAlert(respuesta.message, 'warning', 30)
                } else {
                    showAlert('Registro actualizado', 'success') 
                    listarRegistrosReloj()
                }
                console.log(respuesta.message);
            }).catch((error) => {
                showAlert(error.message, 'danger', 60)
                console.log(error);
            });
            loading.value = false
        }

    }

    const setAdmin = ref(false)
    const changeSetAdmin = () => {
        if (setAdmin.value) {
            claveRelojUser.value = '130116'
            rolRelojUser.value = 14
        } else {
            claveRelojUser.value = ''
            rolRelojUser.value = 0
        }
        
    }

    const loading = ref(false)

    const changeSetReloj = async () => {
        let url = '/config/relojasistencia/setreloj';
        if (setReloj.value >= 0) {
            loading.value = true;
            await axios.put(url, {
                'id' : setReloj.value
            }).then((response) => {
                let respuesta = response.data;
                //console.log(registrosdp.value);
                if(!respuesta.success) {
                    showAlert(respuesta.message, 'warning', 30)
                } else {
                    showAlert(respuesta.message, 'success')
                    infoReloj.value = respuesta.info
                    registrosdp.value = []
                }
                console.log(respuesta.message);
            }).catch((error) => {
                showAlert(error.message, 'danger', 60)
                console.log(error);
            });
            loading.value = false
        } else {
            infoReloj.value = ''
        }
        
    }

    const isAlertActive = ref(false)
    const isAlertDangerActive = ref(false)
    const messageAlert = ref('')
    const messageLastAction = ref('')
    const messageError = ref('')
    /* const error = ref(0)
    const errors = ref([]) */
    const colorAlert = ref('success')
    const errormsg = ref(null)
    const errors = ref(0)
    const alertIndex = ref(0)

    const showAlert = (message = '', type, time = 5) => {

        messageAlert.value = message
        colorAlert.value = type// <-- Tipo define el color
        isAlertActive.value = true

        // grabar última acción
        messageLastAction.value = message

        /* if (color == 'danger') {
            isAlertDangerActive.value = true
        } else {
            isAlertActive.value = true
        } */
        setTimeout(() => {
            isAlertActive.value = false
            //messageAlert.value = '' <-- Comentar para que no halla error de prop indefined en el componente NotificationAlert
            /* if (color == 'danger') {
                isAlertDangerActive.value = false
            } else {
                isAlertActive.value = false
            } */
            errormsg.value = ref(null)
            errors.value = ref(0)
            alertIndex.value = ref(0)
            //isActionMassive.value = false
        }, time * 1000)// LRR bind(this)


    }

    const formatDate = (date, type='') => {
        //var now = new Date().toLocaleDateString()
        var date = new Date(date)// <-- Con let no funcionaba
        //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
        let result =  (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
        if (type == 'ISO') {
            result = date.getFullYear() + '-' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '-' +(date.getDate() > 9 ? '' : '0') + date.getDate()
        }
        return result
    }

    // Ejecutar
    const ejecutarConfirm = ref([])
    const crearStory = (type = 1) => {

        let ruta = 'student-store-story'
        Inertia.put(route(ruta, {
            //'id' : rowID.value,
            'anio' : '2023',
            'type' : type

            }
        ))

    }

    const ejecutar = (type = '') => {

        let ruta = 'student-ejecutar'
        Inertia.put(route(ruta, {
            //'id' : rowID.value,
            'type' : type

            }
        ))

    }

    const cleanVal = () => {

        
    messageLastAction.value = ''
    messageError.value = ''
    idStudentOrder.value = 0
    pinSecurity.value = ''
    }


    const showAyuda = ref([
        {'ordenpago': false},
        {'configuracion': false},
        {'cobranzas': false}
    ])

    const form = ref({
        id_user : 0,
        fecha_hora : ''
    })

    const cleanForm = () => {
        form.id_user = 0,
        form.fecha_hora = ''
    }

    const isModalVisible = ref(false)
    const showModalForm = (show=1) => {
        isModalVisible.value = !isModalVisible.value
        /* if (show) {
            isModalVisible.value = true
        } else {
            isModalVisible.value = false
        } */
        
    }

    const cantObsListSys = ref('')

</script>

<template>
    <Head :title="title" />

    <NotificationAlert v-model="isAlertActive" :message="messageAlert" :color="colorAlert" />

    <BreezeAuthenticatedLayout>
        <template #header>
        <PremiumPageHeader :title="title" :subtitle="'Gestión de ' + title">
        </PremiumPageHeader>
    </template>

        <!-- <CardBoxModal v-model="showDialog" :title="(selectedEvent.title ? selectedEvent.title : 'Información del evento')"
            hasCancel>
            <strong>{{ selectedEvent.start && selectedEvent.start.format('DD/MM/YYYY') }} :
                {{ selectedEvent.start && selectedEvent.start.formatTime() }} -
                {{ selectedEvent.end && selectedEvent.end.formatTime() }}
            </strong>
            <p v-html="selectedEvent.contentFull" />
        </CardBoxModal> -->

        <div class="pb-12">
            <!-- Loader -->
            <div v-if="loading" class="flex flex-col justify-center items-center md:h-[calc(100vh_-113px)] h-[calc(100vh-_114px)] absolute bottom-0 bg-white w-full z-50 bg-opacity-80">
                <div class="border-gray-300 h-20 w-20 animate-spin rounded-full border-8 border-t-rose-600 mb-10" />
                <p class="text-rose-600">Espere por favor ...</p>
            </div>

            <!-- Modal Unens -->
            <Transition
                enter-active-class="ease-out duration-300"
                enter-class="opacity-0"
                enter-to-class="opacity-100"
                leave-active-class="ease-in duration-200"
                leave-class="opacity-100"
                leave-to-class="opacity-0"
                >
                <div v-if="isModalVisible">
                    <div class="fixed inset-0 px-2 z-20 overflow-hidden flex items-center justify-center transition-opacity" >
                        <div @click="showModalForm()" class="absolute bg-black opacity-70 inset-0 z-10">
                        </div>
                        <div class="container  overflow-hidden z-50">
                            <div class="flex flex-row justify-center">
                                <div class="basis-12/12 md:basis-10/12 lg:basis-8/12 xl:basis-5/12 bg-white rounded-md shadow-xl">
                                    <div
                                        class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
                                        <h3 class="text-xl font-semibold text-gray-900 dark:text-white">
                                            Crear nuevo asistencia de forma manual
                                        </h3>
                                        <button @click="showModalForm()" type="button"
                                            class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                                            data-modal-hide="static-modal">
                                            <BaseIcon :path="mdiCloseThick" />
                                        </button>
                                    </div>

                                    <div class="p-4 md:p-5 space-y-4 overflow-y-auto h-[450px]">
                                        <p class="text-base leading-relaxed text-gray-500 dark:text-gray-400">
                                            Esto es en el caso de que no hayan podido registrar su asistencia por algún motivo.
                                        </p>

                                        <div class="relative">
                                            <label class="block font-bold mb-2 ml-2">Colaborador</label>
                                            <select v-model="form.id_user"
                                            class="inline-block ml-2 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
                                            <option value="0" selected>Escoge un colaborador</option>
                                            <option v-for="option in collaborators" :value="option.id">{{ option.apellidos + ' ' + option.nombres }}</option>
                                            </select>
                                        </div>

                                        <div class="relative">
                                            <label class="block font-bold mb-2 ml-2">Fecha Hora</label>
                                            <input type="datetime-local" v-model="form.fecha_hora"
                                            class="inline-block ml-2 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
                                        </div>
                                        
                                    </div>

                                    <div
                                        class="flex items-center justify-end p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">

                                        <button data-modal-hide="static-modal" type="button"
                                            class="btn btn-outline-gray mr-4" @click="showModalForm()">Cerrar</button>
                                        <button data-modal-hide="static-modal" type="button"
                                            class="ms-3 btn btn-rose" @click="storeRegistro()">Aceptar</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </Transition>
            
            <div class="pt-12 pb-6" :class="loading ? 'pointer-events-none' : ''"><!--max-w-7xl-->
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                    <div class="p-4 bg-white border-b border-gray-200">
                        <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->
                        <!-- <div>
                            <div class="mb-2">
                                <h2>.</h2>
                            </div>

                        </div> -->

                        <div v-if="cronjob && cronjob.status == 1" class="mb-6 p-4 bg-emerald-50 border border-emerald-200 rounded-lg text-emerald-800">
                            <div class="flex items-center gap-2 font-bold mb-2 text-emerald-900">
                                <BaseIcon :path="mdiInformationOutline" :size="20" class="text-emerald-700" />
                                <span>Transferencia automática de registros de asistencia activada</span>
                            </div>
                            <div class="text-xs text-emerald-700 ml-7 space-y-1">
                                <p v-if="cronjob.last_output"><strong>Detalle del último proceso:</strong></p>
                                <ul v-if="cronjob.last_output" class="list-disc pl-5 mt-1 bg-white border border-emerald-100 rounded p-3 text-gray-700 max-h-40 overflow-y-auto" v-html="cronjob.last_output"></ul>
                            </div>
                        </div>

                        <CardBox class="mb-6" has-table>
                            <!-- lg:justify-end -->
                            <div class="w-full">
                                <ul>
                                    <li> En esta sección podrá pasar los registros del reloj al sistema. Puede también crear registros manualmente en el sistema por si alguien no llegó a marcar.</li>
                                    <li> Si fuera el caso en el título del listado de registros del sistema puede ver Observados en rojo aquellos que tengan <b>registros de marcación inconsistentes</b>, por ejemplo si marcan duplicado, si considera lo puede eliminar a menos que la marcación sea correcta, puede ser que ingresó y se fue por alguna emergencia. </li>
                                    <li> Si desea controlar y evitar la marcación duplicada desde el reloj lo puede hacer ingresando en el reloj -> Menú Principal -> Sistema -> Asistencia -> <b>Periodo de acceso duplicado (m)</b>. Allí ingresa el tiempo en minutos para que no se registre la marcación si no supera ese tiempo desde la última marcación.</li>
                                </ul>
                                <br>
                                <div class="grid grid-cols-2 gap-3">
                                    <div class="col-span-2 xl:col-span-1">
                                        <div>
                                            <label for="start_date">Fecha Inicio</label>
                                            <input id="start_date" class="rounded-lg w-full" type="date" v-model="startDate">
                                        </div>
                                        <div>
                                            <label for="end_date">Fecha Fin</label>
                                            <input id="end_date" class="rounded-lg w-full" type="date" v-model="endDate">
                                        </div>

                                        <div class="relative ml-2 mt-4">
                                            <BaseButtons type="justify-start" no-wrap>
                                                <BaseButton
                                                    color="info"
                                                    label="Listar registros del sistema"
                                                    small
                                                    @click="listarRegistrosSistema()"
                                                />
                                                
                                            </BaseButtons>
                                        </div>

                                        <!-- {{ entidades }} -->
                                        <!-- <div v-if="entidades.length > 1" class="relative mb-4">
                                            <label class="block font-bold mb-2 ml-2">Entidad</label>
                                            <select v-model="entidad" @change="listarRegistros()"
                                                class="inline-block ml-2 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
                                                <option value="-1" selected>Seleccionar Entidad</option>
                                                <option value="0" selected>Todos</option>
                                                <option v-for="(option, index) in entidades" :value="option.id" :key="option.id">{{ option.label }}</option>
                                            </select>
                                            
                                        </div> -->
                                    </div>
                                    <div class="col-span-2 xl:col-span-1">
                                        <!-- {{ relojes }} -->
                                        <div v-if="relojes.length > 0" class="relative mb-4">
                                            <label class="block font-bold mb-2 ml-2">Reloj</label>
                                            <select v-model="setReloj" @change="changeSetReloj()"
                                                class="inline-block ml-2 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
                                                <option value="-1" selected>Seleccionar reloj</option>
                                                <option value="-2" selected>Importar archivo origen de datos USB</option>
                                                <option v-for="(option, index) in relojes" :value="index" :key="option">{{ option }}</option>
                                            </select>
                                            <span>{{ infoReloj }}</span>
                                        </div>
                                        <div v-if="!startDate || !endDate" class="mx-6 my-2">
                                            <span v-text="'Debe escoger un rango de fecha de inicio y fecha de fin'" class="text-red-600"></span>
                                        </div>
                                        <div v-if="setReloj >= 0 || setReloj == -2" class="relative ml-2">
                                            <BaseButtons v-if="setReloj >= 0" type="justify-start" no-wrap><!-- El primer reloj es cero (array a futuro cambiar por objetos)-->
                                                <BaseButton
                                                    color="info"
                                                    label="Listar registros del reloj"
                                                    small
                                                    @click="listarRegistrosReloj()"
                                                />
                                                <!-- Se representa como un objeto con keys ejm { "29": { "1": 1, "3": "2024-08-06 05:17:01" } } -->
                                                <BaseButton
                                                    v-if="Object.keys(registrosdp).length > 0"
                                                    color="success"
                                                    label="Guardar registros al sistema"
                                                    small
                                                    @click="storeRegistros()"
                                                />
                                                <!-- <BaseButton
                                                    v-if = "ejecutarConfirm['storyantiguos'] == 1"
                                                    color="warning"
                                                    label="Confirmar"
                                                    small
                                                    @click="(crearStory(1), (ejecutarConfirm['storyantiguos']=0))"
                                                /> -->
                                                
                                            </BaseButtons>
                                            <div v-else-if="setReloj == -2">
                                                <ul class="list-inside">
                                                    <li>Cargar archivo attlog.dat (este nombre puede variar dependiendo de la serie del dispositivo)</li>
                                                    
                                                </ul>
                                                <div class="mb-2  mt-2">
                                                    <label>
                                                        <input type="file" id="fileOrder" ref="fileOrder"
                                                            v-on:change="handleFileUploadArchivo" accept=".TXT, .txt, .DAT, .dat"
                                                            class="w-full input-file input-file-slate" />
                                                    </label>
                                                </div>
                                                <div class="mb-4">
                                                    <button v-on:click="eventSubirArchivo('/relojasistencia/importArchivo')"
                                                        class="btn btn-rose">Cargar archivo</button>
                                                </div>
                                                <BaseButtons type="justify-start" no-wrap>
                                                    <!-- Se representa como un array ejm [ { "1": "1", "3": "2024-08-05 13:05:00" }, { "1": "1", "3": "2024-08-05 18:13:22" } ] -->
                                                    <BaseButton
                                                        v-if="registrosdp.length > 0"
                                                        color="success"
                                                        label="Guardar registros al sistema"
                                                        small
                                                        @click="storeRegistros()"
                                                    />
                                                    <!-- <BaseButton
                                                        v-if = "ejecutarConfirm['storyantiguos'] == 1"
                                                        color="warning"
                                                        label="Confirmar"
                                                        small
                                                        @click="(crearStory(1), (ejecutarConfirm['storyantiguos']=0))"
                                                    /> -->
                                                    
                                                </BaseButtons>
                                            </div>
                                        </div>
                                        <!-- Opciones de admin-->
                                        <!-- {{ setAdmin + ' rol: ' +rolRelojUser + ' clave: ' +claveRelojUser }} -->
                                        <!-- <div v-if="Object.keys(registrosdp).length > 0" class="p-4">
                                            <div>
                                                <label class="checkbox">
                                                <input v-model="setAdmin" type="checkbox" @change="changeSetAdmin()"/>
                                                <span class="check mr-2"> Establecer como Admin a un colaborador</span>
                                                </label>
                                            </div>
                                            <div v-if="setAdmin">
                                                <select v-model="rolRelojUser" 
                                                class="inline-block ml-2 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
                                                <option value="0" selected>Normal</option>
                                                <option value="2">Registrador</option>
                                                <option value="12">Supervisor</option>
                                                <option value="14">Admin</option>
                                                
                                                </select>

                                                <input name="relojclave" class="ml-3 rounded-lg" type="text" v-model="claveRelojUser">
                                            </div>

                                        </div> -->

                                    </div>
                                </div>
                                
                                
                            </div>
                        </CardBox>
                    </div>
                </div>
            </div>
            
            <!-- Sección listas -->
            <div class="pb-4">
                <div class="grid gap-4 cols-1 xl:grid-cols-2 mb-6">
                    <div class=" bg-white rounded-lg shadow-lg p-6">
                        <div>
                            <h2 class="">Registros del sistema</h2>
                            <small v-if="cantObsListSys" class="text-red-600" title="Puede que haya marcaciones con 60 minutos Aprox. de diferencia (puede que sea correcto o que hayan marcado doble)">Posibles Duplicados: [{{  cantObsListSys }}]</small>
                            <table class="min-w-full text-sm font-light table-responsive-wfull" :set="contObs=''">
                                <thead class="border-b bg-white font-medium dark:border-neutral-500 dark:bg-neutral-600" :set="lastIdCol=null">
                                    <tr>
                                        <!-- <th scope="col" class="">#</th> -->
                                        <!-- <th scope="col" class="">ID</th> -->
                                        <th scope="col" class="">Colaborador</th>
                                        <th scope="col" class="">Fecha/Hora</th>
                                        <th scope="col" class="">Estado</th>
                                        <th scope="col" class="text-center">
                                            <div class="text-center">
                                                <BaseButton
                                                    title="Añadir registro manual"
                                                    color="info"
                                                    small
                                                    :icon="mdiPlusCircle"
                                                    @click="showModalForm()"
                                                />
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody :set="lastDate=null">
                                    <tr v-if="registrosSistema.length" v-for="(client, index) in registrosSistema"
                                        :key="client.id"
                                        class="border-b bg-neutral-100 dark:border-neutral-500 dark:bg-neutral-700">
                                        <!-- <td class="whitespace-nowrap border-none font-medium border-r-0">{{ index + 1 }}
                                        </td> -->
                                        <!-- <td class="whitespace-nowrap border-none font-medium border-r-0" data-label="ID">{{ client.id }}
                                        </td> -->
                                        <td class="whitespace-nowrap border-none" data-label="Nombre" :set="regDate=new Date(client.fecha_hora)">{{ client.apellidos }} {{ client.nombres }}</td>
                                        <!-- Object.keys(registrosdp).length > 0  -->
                                        <td class="whitespace-nowrap border-none" data-label="Fecha Hora"
                                            :class="(lastDate && regDate < lastDate.setMinutes(60) && lastIdCol == client.id_user ? 'text-red-600' : '')"
                                            :set="(lastDate && regDate < lastDate.setMinutes(60) && lastIdCol == client.id_user ? contObs+=client.apellidos+', ' : '')">{{ client.fecha_hora }}</td>
                                        <td class="whitespace-nowrap border-none" data-label="Estado" :set="lastDate=new Date(client.fecha_hora)">
                                            
                                            <small :class="(client.status == 1 ? 'text-green-600' : 'text-yellow-600')">
                                                {{ client.status == 1 ? 'Reloj' : 'Manual' }}
                                            </small>
                                        </td>
                                        <td class="whitespace-nowrap border-none" style="padding:0;" :set="lastDate.setMinutes(60)">
                                            <div class="text-center" :set="lastIdCol=client.id_user">
                                                <BaseButton
                                                    title="Eliminar"
                                                    color="danger"
                                                    small
                                                    :icon="mdiTrashCan"
                                                    @click="deleteRegistroSistema(client.id, client.apellidos + ' ' + client.nombres)"
                                                />
                                            </div>
                                            <!--label="Actualizar en Disp." <small @click="updateRelojUsers(client.id, client.apellidos + ' ' + client.nombres, claveRelojUser, rolRelojUser)" class="text-blue-700 hover:text-green-600">Actualizar en Disp.</small> -->
                                        </td>
                                    </tr>
                                    <tr v-else class="border-b bg-white dark:border-neutral-500 dark:bg-neutral-600">
                                        <td class="whitespace-nowrap border-none font-medium" colspan="2"><span> No existen
                                                registros …</span></td>

                                    </tr>

                                </tbody>
                            </table>
                        </div>
                        <hr class="h-px my-8 bg-gray-200 border-0 dark:bg-gray-700" :set="cantObsListSys=contObs">
                        <!-- <div class="mt-6">
                            <h5 class="text-xl text-gray-900 font-bold mb-8 ml-3">Colaboradores en dispositivo</h5>
                            <table class="min-w-full text-sm font-light table-responsive-wfull">
                                <thead class="border-b bg-white font-medium dark:border-neutral-500 dark:bg-neutral-600">
                                    <tr>
                                        <th scope="col" class="">#</th>
                                        <th scope="col" class="">Alumno</th>
                                        <th scope="col" class="">Fecha de compromiso</th>
                                        
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="colaboradoresdp.length" v-for="(client, index) in colaboradoresdp"
                                        :key="client.id"
                                        class="border-b bg-neutral-100 dark:border-neutral-500 dark:bg-neutral-700">
                                        <td class="whitespace-nowrap border-none font-medium border-r-0">{{ index + 1 }}
                                        </td>
                                        <td class="whitespace-nowrap border-none">{{ client.apellidos }} {{ client.nombres }}</td>
                                        <td class="whitespace-nowrap border-none" :class="(client.fecha_compromiso_pago && client.fecha_compromiso_pago < (formatDate(new Date(), 'ISO')) ? 'text-red-600' : '')"> {{ client.fecha_compromiso_pago }} </td>
                                    </tr>
                                    <tr v-else class="border-b bg-white dark:border-neutral-500 dark:bg-neutral-600">
                                        <td class="whitespace-nowrap border-none font-medium" colspan="3"><span> No existen
                                                registros …</span></td>

                                    </tr>

                                </tbody>
                            </table>
                        </div> -->
                        
                    </div>
                    <div class=" bg-white rounded-lg shadow-lg p-6">
                        <h5 class="text-xl text-gray-900 font-bold mb-8 ml-3">Registros del dispositivo reloj ({{ Object.keys(registrosdp).length  }})
                        </h5>
                    <!-- {{ registrosdp }} -->
                        <table class="min-w-full text-sm font-light table-responsive-wfull">
                            <thead class="border-b bg-white font-medium dark:border-neutral-500 dark:bg-neutral-600">
                                <tr>
                                    <!-- <th scope="col" class="">ID</th> -->
                                    <th scope="col" class="">ID Colaborador</th>
                                    <th scope="col" class="">Fecha/Hora</th>
                                    <th scope="col" class=""></th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr v-for="(client, index) in registrosdp"
                                    :key="client"
                                    class="border-b bg-neutral-100 dark:border-neutral-500 dark:bg-neutral-700">
                                    <!-- <td class="whitespace-nowrap border-none font-medium border-r-0">{{ index + 1 }}
                                    </td> -->
                                    <!-- <td class="whitespace-nowrap border-none font-medium border-r-0">{{ client[0] }}
                                    </td> -->
                                    <td class="whitespace-nowrap border-none">{{ client[1] }} </td>
                                    <td class="whitespace-nowrap border-none">{{ client[3] }} </td>
                                    <td v-if="setReloj >= 0" class="whitespace-nowrap border-none" style="padding:0;">
                                        <div class="text-center">
                                            <!-- <BaseButton
                                                title="Eliminar"
                                                color="danger"
                                                small
                                                :icon="mdiTrashCan"
                                                @click="deleteRegistroReloj(client[0], client[1])"
                                            /> -->
                                        </div>
                                        <!--label="Actualizar en Disp." <small @click="updateRelojUsers(client.id, client.apellidos + ' ' + client.nombres, claveRelojUser, rolRelojUser)" class="text-blue-700 hover:text-green-600">Actualizar en Disp.</small> -->
                                    </td>
                                </tr>
                                


                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>
    </BreezeAuthenticatedLayout>
</template>
<style scoped>
.vuecal__event {
    cursor: pointer;
}

.vuecal__event-title {
    font-size: 1.2em;
    font-weight: bold;
    margin: 4px 0 8px;
}

.vuecal__event-time {
    display: inline-block;
    margin-bottom: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}

.vuecal__event-content {
    font-style: italic;
}
</style>
